import React, { useEffect, useState } from 'react';
import './App.css';
import {BrowserRouter as Router, Route, Routes, useNavigate, useParams} from "react-router-dom";
import {EditWord} from "./screens/EditWord";
import {initializeIcons} from '@uifabric/icons';
import {Fabric, SearchBox} from 'office-ui-fabric-react';
import {GlobalSettings} from "./GlobalSettings";
import {useAuth0} from "./utils/Auth0Provider";
import {LoginScreen} from "./screens/LoginScreen";
import {setGlobalAuthKey} from "languagetool-editor/src/js/integrations/Market/api";
import {ApolloRoot} from "./ApolloRoot";
import {FabricUIFormControls} from "./components/FabricUIFormControls";
import {FormUISwitcher} from "languagetool-editor/src/js/components/FormUISwitch";
import Link from "./components/Link";
import MainScreen from "./screens/WordList";
import {IconButton} from 'office-ui-fabric-react';
import styles from "./Navigation.module.css";
import {TodosPage} from "./screens/Todos";
import {ActivityLogPage} from "./screens/ActivityLog";
import {MessageBarProvider, MessageBarRender} from "./components/MessageBarManager";
import {RecordingWorkflowScreen} from "./screens/RecordingWorkflow/Screen";
import {getDevAuthHeader, initDevAuthHeader} from "./utils/authHeader";


export default function App() {
  useEffect(() => {
    initializeIcons();
  }, []);

  const {isAuthenticated, getTokenSilently} = useAuth0();
  const [devAuthHeader] = useState(() => initDevAuthHeader());

  // We need to init the global api key for the old-style calls in languagetool-editor
  useEffect(() => {
    if (devAuthHeader) {
      setGlobalAuthKey(devAuthHeader);
    } else if (isAuthenticated) {
      getTokenSilently().then((token: any) => {
        setGlobalAuthKey(`Bearer ${token}`);
      })
    }
  }, [devAuthHeader, isAuthenticated])

  return (
    <Router>
      <Routes>
        <Route path="/*" element={
          <ApolloRoot
            getAuthHeader={async () => {
              if (devAuthHeader) {
                return devAuthHeader;
              }
              else if (isAuthenticated) {
                const token = await getTokenSilently();
                return `Bearer ${token}`;
              }
              else {
                return "";
              }
            }}
          >
            <GlobalSettings>
              <Fabric>
                <FormUISwitcher
                  uiControls={FabricUIFormControls}
                >
                  <div className="App">
                    <LoginLock>
                      <AppRouter />
                    </LoginLock>
                  </div>
                </FormUISwitcher>
              </Fabric>
            </GlobalSettings>
          </ApolloRoot>
        } />
      </Routes>
    </Router>
  );
}

function LoginLock(props: {
  children: any
}) {
  const {isAuthenticated, loading: authLoading} = useAuth0();

  let contents;
  if (getDevAuthHeader() || isAuthenticated) {
    contents = props.children;
  } else if (authLoading) {
    contents = null;
  } else {
    contents = <LoginScreen />
  }

  return contents;
}


function RecordingSessionRouteWrapper() {
  const { id } = useParams();
  return <RecordingWorkflowScreen recordingSessionId={id!} style={{height: '100vh'}} />;
}

function AppRouter(props: {}) {
  return <MessageBarProvider>
    <Routes>
      <Route path="/recording-session/:id" element={<RecordingSessionRouteWrapper />} />
      <Route path="/*" element={
        <>
          <Nav />
          <MessageBarRender />
          <Routes>
            <Route path="/log" element={<ActivityLogPage />} />
            <Route path="/todos" element={<TodosPage />} />
            <Route path="/word/:id" element={<EditWord />} />
            <Route path="*" element={<MainScreen />} />
          </Routes>
        </>
      } />
    </Routes>
  </MessageBarProvider>
}


function Nav(props: {}) {
  const navigate = useNavigate();
  const {logout} = useAuth0();

  return <div className={styles.nav}>
    <Link href={"/log"}>Log</Link>
    &nbsp;&bull;&nbsp;
    <Link href={"/todos"}>Todos</Link>
    &nbsp;&bull;&nbsp;
    <Link href={"/"}>Words</Link>

    <div style={{flex: 1}}></div>

    <SearchBox
      styles={{ root: { width: 200 } }}
      placeholder="Search Words"
      onSearch={newValue => {
        navigate('/?search=' + newValue);
      }}
    />

    <div style={{width: '50px'}}></div>

    <IconButton
      style={{float: 'right'}}
      iconProps={{iconName: 'leave'}} title="Logout" ariaLabel="Logout"
      onClick={() => logout()}
    />
  </div>
}
